import React, {useEffect} from "react";
import {PrimaryCollapsibleSection} from "../../../../../elements/collapsableSection/primary/PrimaryCollapsibleSection";
import {CardField} from "./components/CardField";
import {FollowUpCard} from "../../../../../elements/followUpCard/FollowUpCard";
import {BookedServiceCallBackChatEventDTO, RequestedServiceCallbackChatEventDTO} from "../../../../../../api/generated";
import {fetchLocationById, locationSelector} from "../../../../location/locationSlice";
import {useAppDispatch, useAppSelector} from "../../../../../../app/hooks";

interface ServiceCallbackChatEventCardProps {
    serviceCallbackChatEvent: BookedServiceCallBackChatEventDTO | RequestedServiceCallbackChatEventDTO
}

export const ServiceCallbackChatEventCard: React.FC<ServiceCallbackChatEventCardProps> = ({
                                                                                              serviceCallbackChatEvent
                                                                                          }) => {
    const dispatch = useAppDispatch();

    const location = useAppSelector(locationSelector);

    useEffect(() => {
        if (serviceCallbackChatEvent.location_identifier) {
            dispatch(
                fetchLocationById(
                    serviceCallbackChatEvent.location_identifier
                )
            );
        }
    }, [dispatch, serviceCallbackChatEvent.location_identifier]);

    return <PrimaryCollapsibleSection title={"Service Callback Request"}>
        <CardField
            title={"Type"}
            valueComponent={FollowUpCard}
            props={{eventType: serviceCallbackChatEvent.event_type}}
        />
        <CardField
            title="Location Name"
            value={location?.name || "Unknown Location"}
        />
        {"preferred_date_time" in serviceCallbackChatEvent && serviceCallbackChatEvent.preferred_date_time && (
            <CardField
                title="Preferred Date/Time"
                value={serviceCallbackChatEvent.preferred_date_time}
            />
        )}
        <CardField
            title="User Name"
            value={serviceCallbackChatEvent.service_call_back_user_name}
        />
        <CardField
            title="User Phone Number"
            value={serviceCallbackChatEvent.service_call_back_user_phone_number}
        />
        {serviceCallbackChatEvent.user_vehicle_vrm && <CardField
            title="VRM"
            value={serviceCallbackChatEvent.user_vehicle_vrm}
        />}
        {("service_call_back_vehicle_mileage" in serviceCallbackChatEvent && serviceCallbackChatEvent.service_call_back_vehicle_mileage) && <CardField
            title="Vehicle Mileage"
            value={serviceCallbackChatEvent.service_call_back_vehicle_mileage}
        />}
    </PrimaryCollapsibleSection>
}
